import React, { useRef, useState } from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Select,
  Button,
  Flex,
  InputRightElement,
  InputGroup,
  Text,
} from '@chakra-ui/react';
import { FaRegClock } from 'react-icons/fa';
import axios from 'axios';
import toast from 'react-hot-toast';

const ProductHunt = () => {
  const [timeZone, setTimeZone] = useState('IST');
  const [reminderTime, setReminderTime] = useState('');
  const [email, setEmail] = useState('');
  const timeInputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    // Add your logic to handle form submission here
    setLoading(true);
    try {
      const res = await axios.post(
        'https://bounce.mailamp.in/reminder/create',
        { time: reminderTime, zone: timeZone, email: email },
      );
      console.log(res);
      toast.success(res.data.msg);
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.msg);
    } finally {
      setLoading(false);
    }
  };

  const handleTimeInputClick = () => {
    timeInputRef.current.showPicker();
  };

  return (
    <Flex
      justify="center"
      align="center"
      h="100vh"
      bgGradient="linear(to-r, #a2d6f9 0%, #e6e6f3 50%, #a2d6f9 100%)"
      backdropFilter="blur(5px)"
    >
      <Box
        w="100%"
        maxW="md"
        px="6"
        py="8"
        bg="white"
        boxShadow="lg"
        rounded="lg"
      >
        <Box mb={8} textAlign="center">
          <Text fontSize="4xl" fontWeight="bold" mb={2} color="#2875ff">
            Setup a daily reminder to log into Product Hunt
          </Text>
        </Box>
        <form onSubmit={handleSubmit}>
          <FormControl isRequired>
            <FormLabel>What time should we remind you?</FormLabel>
            <Flex alignItems="center">
              <Select
                value={timeZone}
                onChange={(e) => setTimeZone(e.target.value)}
                placeholder="Select time zone"
                mr={4}
              >
                <option value="IST">IST</option>
                <option value="EST">EST</option>
                <option value="PST">PST</option>
                {/* Add more options for time zones if needed */}
              </Select>
              <InputGroup onClick={handleTimeInputClick}>
                <Input
                  type="time"
                  value={reminderTime}
                  onChange={(e) => setReminderTime(e.target.value)}
                  placeholder="Reminder time"
                  ref={timeInputRef}
                />
              </InputGroup>
            </Flex>
          </FormControl>

          <FormControl mt={4} isRequired>
            <FormLabel>Which email should we send the reminder to?</FormLabel>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter email address"
            />
          </FormControl>

          <Flex justify="center">
            <Button
              mt={4}
              variant="brand"
              type="submit"
              isLoading={loading}
              isDisabled={loading}
            >
              Submit
            </Button>
          </Flex>
        </form>
      </Box>
    </Flex>
  );
};

export default ProductHunt;
